import { fetchWithoutToken } from '../utils/fetch';

export const getInfoUserKajabi = async (email, institutionCode) => {
	try {
		const res = await fetchWithoutToken.post(
			`/kajabi`,
			{
				email,
				institution_code: institutionCode,
			},
			{
				headers: {
					Authorization: `Bearer ${localStorage.token}`,
				},
			},
		);

		return res;
	} catch (error) {
		const backendDetail = error?.response?.data?.detail;
		let message = 'Kajabi authentication failed.';
		if (Array.isArray(backendDetail)) {
			message = backendDetail.join(', ');
		} else if (backendDetail && typeof backendDetail === 'object') {
			message = backendDetail.message || message;
			if (Array.isArray(backendDetail.categories) && backendDetail.categories.length) {
				message = `${message}, contact your administrator`;
			}
		} else if (backendDetail) {
			message = backendDetail;
		}
		console.error('Kajabi auth error.', error);
		throw new Error(message);
	}
};
